/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { HttpResponse, Logger } from '@app/core';
import { Activity } from '@app/shared/components/activities/activity.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiQuery } from '@app/core/http/api-query';
import { LaravelModelsEnum } from '@app/shared/models/model.model';
import { ActivitiesService } from '@app/shared/components/activities/activities.service';
import { Sidebar } from 'primeng/sidebar';

const log = new Logger('ActivitiesComponent');

@Component({
  selector: 'app-activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.scss'],
})
export class ActivitiesComponent implements OnInit {
  tabsIndex = 0;

  subjectType: LaravelModelsEnum;
  subjectId: number;
  overlay = true;

  classes = 'activities-sidebar';

  isVisible = false;
  activityResponse: PaginatedResponse = new PaginatedResponse();
  loading = true;
  Object = Object;

  @ViewChild(Sidebar, { static: true }) activitiesSideBar: Sidebar;

  constructor(private http: HttpClient, private activities: ActivitiesService) {}

  ngOnInit() {
    this.activities.open.subscribe((res: any) => {
      this.subjectType = res.subjectType;
      this.subjectId = res.subjectId;
      this.overlay = res.overlay;

      // this.buildClasses();

      setTimeout(() => {
        this.show();
      });
    });

    this.activities.close.subscribe(() => {
      this.isVisible = false;
    });
  }

  /**
   * Generate all necessary CSS classes
   */
  buildClasses() {
    this.activities.passOptions.subscribe((options: any) => {
      if (options.modalOpened) {
        this.classes += ' with-modal';
      } else {
        this.classes = this.classes.replace(' with-modal', '');
      }
      if (options.notStatic) {
        this.classes = this.classes.replace(' activities-sidebar-static', '');
      } else if (!this.overlay) {
        this.classes += ' activities-sidebar-static';
      }
    });
  }

  show() {
    this.isVisible = true;
    this.paginate();
    this.activities.isOpened = true;
    this.buildClasses();
  }

  onHide() {
    this.activities.optionsPass({});
    this.subjectType = null;
    this.subjectId = null;
    this.activities.isOpened = false;
    this.isVisible = false;

    const mask = document.querySelector('.p-sidebar-mask') as HTMLElement;
    if (mask) { mask.remove(); }
    this.activitiesSideBar?.hide();

    this.buildClasses();
  }

  paginate(event: any = null) {
    if (!this.isVisible || this.tabsIndex === 0) {
      return;
    }
    this.loading = true;
    let page = 1;

    if (event && event.first > 0) {
      page = event.first / event.rows + 1;
    }

    log.debug('aaaaaaa');

    return this.loadData(page).subscribe((response: PaginatedResponse) => {
      this.activityResponse = response;
      this.loading = false;
    });
  }

  toString(any: any) {
    return any.toString();
  }

  stringify(any: any) {
    return JSON.stringify(any);
  }

  /**
   * Custom tabs navigation
   *
   * @param index Tab index
   */
  openTab(index: number) {
    this.tabsIndex = index;

    if (this.tabsIndex === 1) {
      this.loadData();
    }
  }

  /**
   * Close sidebar
   */
  closeSidebar() {
    this.activities.hide(this.subjectType);
  }

  /**
   * Load data
   *
   * @param page Number
   */
  private loadData(page: number = 1): Observable<PaginatedResponse> {
    log.debug('loadData');
    const query = new ApiQuery().setPage(page).addFilters({
      subject_type: this.subjectType,
      subject_id: this.subjectId,
    });

    return this.http.get('v1/activities', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((revision: any) => {
          return new Activity().deserialize(revision);
        });
        return new PaginatedResponse().deserialize(response);
      })
    );
  }
}
